module.exports = __webpack_public_path__ + "img/church_thumbnail.d46e3e40.jpg";